var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imgUrl != null && _vm.imgUrl != '')?_c('div',{staticClass:"header-image w-1920"},[_c('Uimage',{attrs:{"src":_vm.imgUrl}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }